import * as z from "zod";
import { gql } from "graphql-request";

import { SysSchema, SysFragment } from "./sys";
import { TargetingSchema, TargetingFragment } from "./targeting";
import { RelatedMediaSchema, RelatedMediaFragment } from "./relatedMedia";
import {
  CarouselEventEntrySchema,
  CarouselEventEntryFragment,
} from "./newsEntryTypes/carouselEventEntry";
import {
  CarouselEventPollEntrySchema,
  CarouselEventPollEntryFragment,
} from "./newsEntryTypes/carouselEventPollEntry";

import {
  CarouselEventPollTargetsEntrySchema,
  CarouselEventPollTargetsEntryFragment,
} from "./newsEntryTypes/carouselEventPollTargetsEntry";

import {
  CarouselEventProgressTrackerEntryFragment,
  CarouselEventProgressTrackerEntrySchema,
} from "./newsEntryTypes/carouselEventProgressTrackerEntry";

export const EventEntrySchema = z.object({
  __typename: z.literal("CarouselEvent"),
  sys: SysSchema,
  sortDate: z.string().nullable(),
  targeting: TargetingSchema.nullable(),
  relatedMedia: RelatedMediaSchema.nullable(),
  localized: z
    .discriminatedUnion("__typename", [
      CarouselEventEntrySchema,
      CarouselEventPollEntrySchema,
      CarouselEventPollTargetsEntrySchema,
      CarouselEventProgressTrackerEntrySchema,
    ])
    .nullish(),
});

export const EventEntry = EventEntrySchema;
export type EventEntry = z.infer<typeof EventEntrySchema>;

export const EventEntryFragment = gql`
  fragment EventEntryFragment on CarouselEvent {
    __typename

    sys {
      ...SysFragment
    }

    targeting {
      ...TargetingFragment
    }

    relatedMedia {
      ...RelatedMediaFragment
    }

    sortDate
    localized {
      ... on CarouselEventEntry {
        ...CarouselEventEntryFragment
      }
      ... on CarouselEventPollEntry {
        ...CarouselEventPollEntryFragment
      }
      ... on CarouselEventPollTargetsEntry {
        ...CarouselEventPollTargetsEntryFragment
      }
      ... on CarouselEventProgressTrackerEntry {
        ...CarouselEventProgressTrackerEntryFragment
      }
    }
  }

  ${SysFragment}
  ${CarouselEventEntryFragment}
  ${CarouselEventPollEntryFragment}
  ${CarouselEventPollTargetsEntryFragment}
  ${CarouselEventProgressTrackerEntryFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
`;
